/**
 * LBH section reveal: IntersectionObserver + design mode friendly.
 */
(function () {
  'use strict';

  var ATTR = 'data-lbh-reveal';
  var VISIBLE = 'lbh-is-visible';
  var SEL = '[' + ATTR + ']';

  function initObserver(root) {
    if (!('IntersectionObserver' in window)) {
      markAllVisible(root);
      return null;
    }

    var io = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting && entry.target) {
            entry.target.classList.add(VISIBLE);
            io.unobserve(entry.target);
          }
        });
      },
      { root: null, rootMargin: '0px 0px -8% 0px', threshold: 0.08 }
    );

    query(root).forEach(function (el) {
      io.observe(el);
    });

    return io;
  }

  function query(root) {
    return Array.prototype.slice.call((root || document).querySelectorAll(SEL));
  }

  function markAllVisible(root) {
    query(root).forEach(function (el) {
      el.classList.add(VISIBLE);
    });
  }

  function refresh(root) {
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      markAllVisible(root);
      return;
    }
    initObserver(root);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      refresh();
    });
  } else {
    refresh();
  }

  document.addEventListener('shopify:section:load', function (ev) {
    if (ev && ev.target) refresh(ev.target);
  });
})();
